"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customSqlSingleCopyButtonClass = exports.customSqlCopyButtonStyle = exports.customSqlDividerClass = exports.customSqlWorkbookInlineClass = exports.customSqlGeneralInlineClass = exports.codeTextClass = exports.customSqlQueryTextClass = exports.customSqlQuerySublistClass = exports.customSqlQueryListClass = exports.customSqlDialogStyle = exports.customSqlDialogHeight = exports.customSqlDialogWidth = void 0;
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
exports.customSqlDialogWidth = 500;
exports.customSqlDialogHeight = 500;
const dividerWidth = 468; // custom sql dialog width minus padding
const copyButtonLeftMargin = 371; // dialog width minus padding and copy button length
exports.customSqlDialogStyle = {
    paddingTop: widgets_1.TabStyles.Spacing.MediumSpace + 4,
    paddingRight: widgets_1.TabStyles.Spacing.MediumSpace + 4,
    paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace + 4,
    paddingBottom: widgets_1.TabStyles.Spacing.MediumSpace,
};
exports.customSqlQueryListClass = (0, vizportalclient_common_components_1.cssClass)('customSqlQueryList', {
    listStyleType: 'none',
    color: widgets_1.TabStyles.Colors.L8,
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    padding: 0,
    margin: 0,
});
exports.customSqlQuerySublistClass = (0, vizportalclient_common_components_1.cssClass)('customSqlQuerySublist', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    padding: 0,
    marginLeft: widgets_1.TabStyles.Spacing.DefaultSpace + 2,
});
exports.customSqlQueryTextClass = (0, vizportalclient_common_components_1.cssClass)('customSqlQueryText', {
    marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    marginRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowX: 'auto',
});
exports.codeTextClass = (0, vizportalclient_common_components_1.cssClass)('codeTextClass', {
    fontFamily: 'Courier New',
});
exports.customSqlGeneralInlineClass = (0, vizportalclient_common_components_1.cssClass)('customSqlInline', {
    marginTop: widgets_1.TabStyles.Spacing.LargeSpace,
    marginBottom: widgets_1.TabStyles.Spacing.SmallSpace + 2,
    marginRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    marginLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
});
exports.customSqlWorkbookInlineClass = (0, vizportalclient_common_components_1.cssClass)('customSqlInline', {
    marginTop: 0,
    marginBottom: widgets_1.TabStyles.Spacing.SmallSpace,
    marginRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    marginLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
});
exports.customSqlDividerClass = (0, vizportalclient_common_components_1.cssClass)('customSqlDivider', {
    marginTop: widgets_1.TabStyles.Spacing.MediumSpace + 2,
    marginBottom: widgets_1.TabStyles.Spacing.MediumSpace + 2,
    display: 'inline-block',
    height: 1,
    width: dividerWidth,
    backgroundColor: widgets_1.TabStyles.Colors.L3,
});
exports.customSqlCopyButtonStyle = {
    marginLeft: copyButtonLeftMargin,
    marginTop: 50,
};
exports.customSqlSingleCopyButtonClass = (0, vizportalclient_common_components_1.cssClass)('customSqlSingleCopyButton', {
    marginLeft: copyButtonLeftMargin,
});
//# sourceMappingURL=CustomSqlStyles.js.map